export function useJsonToClass<T>(model: new (...args: any[]) => T, json: any): T | T[] {
  if (Array.isArray(json)) {
    return json.map((item) => new model(item));
  }
  return new model(json);
}
